module.exports = require("seqparse");